import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import React, {useState} from 'react';
import {withRouter} from 'react-router-dom';
import Formatos from '../../../../../helpers/formatos';
import {compartilharCard} from "../../../../../services/usuario/UsuarioService";
import useStyles from '../styles';
import CompartilharCard from "../compartilhar";

const QuemEQuemCardEquipeTecnica = (props) => {
  const classes = useStyles();
  const { equipeTecnica } = props;
  const [foto, setFoto] = useState(null);
  const [openCompartilhar, setOpenCompartilhar] = useState(false);

  const visualizar = () => {
    props.history.push(`/usuario/${id}`)
  };

  const handleOpenCompartilhar = async (event) => {
    event.stopPropagation();
    setOpenCompartilhar(true);
  };

  const { id, idUsuarioPerfil, nome, sobrenome, siglaEntidade, ocupacao, emailInstitucional, telefone, siglaAtuacao } = equipeTecnica;

  return (
    <div>
      <Card onClick={visualizar} className={classes.cartao} style={{ height: '238px' }}>
        <ShareOutlinedIcon className={classes.shareButton} onClick={handleOpenCompartilhar} />
        <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {foto ? <Avatar src={foto} alt="foto de perfil" />
            : <div className={classes.imagemReplaceFoto}>{nome.substring(0, 2).toUpperCase()}</div>}
          <p className={classes.pNome}>{nome} {sobrenome}</p>
          <p className={classes.pPerfil}>{'Equipe Técnica'}</p>
          {/*<p className={classes.pSigla}>{siglaEntidade}</p>*/}
          <p className={classes.pSigla}>Sebrae {siglaAtuacao}</p>
          <p className={classes.pSigla}>{ocupacao}</p>
          <p className={classes.pEmail}>{emailInstitucional}</p>
          <p className={classes.pPerfil}>{Formatos.telefone(telefone)}</p>
        </CardContent>
      </Card>
      <CompartilharCard open={openCompartilhar} onClose={() => setOpenCompartilhar(false)} onCompartilharCard={compartilharCard} id={idUsuarioPerfil}/>
    </div>
  );
};

export default withRouter(QuemEQuemCardEquipeTecnica);
